import { PITCH_GEOMETRY } from './PitchGeometry';

export interface Vector2 {
  x: number;
  y: number;
}

export const vector = (x = 0, y = 0): Vector2 => ({ x, y });

export const add = (a: Vector2, b: Vector2): Vector2 => ({ x: a.x + b.x, y: a.y + b.y });
export const subtract = (a: Vector2, b: Vector2): Vector2 => ({ x: a.x - b.x, y: a.y - b.y });
export const scale = (value: Vector2, factor: number): Vector2 => ({ x: value.x * factor, y: value.y * factor });
export const length = (value: Vector2): number => Math.hypot(value.x, value.y);
export const distance = (a: Vector2, b: Vector2): number => length(subtract(a, b));
export const normalize = (value: Vector2): Vector2 => {
  const magnitude = length(value);
  return magnitude > 1e-9 ? scale(value, 1 / magnitude) : vector();
};
export const moveTowards = (current: Vector2, target: Vector2, maxDelta: number): Vector2 => {
  const difference = subtract(target, current);
  const magnitude = length(difference);
  return magnitude <= maxDelta || magnitude < 1e-9
    ? { ...target }
    : add(current, scale(difference, maxDelta / magnitude));
};
export const clamp = (value: number, minimum: number, maximum: number): number => (
  Math.max(minimum, Math.min(maximum, value))
);
export const clampPosition = (position: Vector2): Vector2 => PITCH_GEOMETRY.clampPlayable(position);
export const lerp = (from: number, to: number, amount: number): number => from + (to - from) * amount;
